import { faGithub, faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { graphql, Link } from "gatsby"
import * as React from "react"
import { DefaultBottom } from "../components/banner/DefaultBottom"
import { Post } from "../components/blog/Post"
import { HTMLContent } from "../components/common/Content"
import Layout from "../components/layout/Layout"
import { MemberInfo } from "../components/utils/Model"
import UserIcon from "../components/team/Icon"

// props
interface Props {
  data: {
    page: MemberInfo
    posts?: {
      nodes: Array<{
        id: string
        frontmatter: {
          title: string
          publishedAt: string
          author: string
          category: string
          disqus: string
        }
        fields: {
          path: string
        }
        excerpt: any
      }>
    }
  }
}

// markup
const AuthorTemplate = (props: Props) => {
  const member = props.data.page
  const posts = props.data?.posts?.nodes || []

  return (
    <Layout
      seo={{
        title: `Author | ${props.data.page.frontmatter.title}`,
        hasNoSpring: true,
      }}
      className="author"
    >
      <div className="container">
        <div className="pt-5 pb-5">
          <Link to={"/authors"} className="button is-white is-white-spring">
            <FontAwesomeIcon className="icon" icon={faAngleLeft} />
            Blog post Authors
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="columns m-0">
          <div className="column is-3 has-background-light has-text-centered mb-6 px-6 py-6 mr-6">
            <div className="avatar">
              {member.frontmatter.gravatar ? (
                <>
                  <img
                    src={member.frontmatter.gravatar}
                    alt={member.frontmatter.title}
                  />
                  <div className="extra"></div>
                </>
              ) : (
                <UserIcon className="svg" />
              )}
            </div>
            <h1 className="is-size-4 has-text-weight-bold pb-2 pt-4">
              {member.frontmatter.title}
            </h1>
            {!member.frontmatter.inactive ? (
              <div>
                {(member.frontmatter.github || member.frontmatter.twitter) && (
                  <div className="social">
                    {member?.frontmatter.github && (
                      <a
                        href={`https://github.com/${member.frontmatter.github}`}
                        className="mr-4"
                        title="Github"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                    )}
                    {member.frontmatter.twitter && (
                      <a
                        href={`https://twitter.com/${member.frontmatter.twitter}`}
                        title="Twitter"
                        className=""
                      >
                        <FontAwesomeIcon icon={faXTwitter} />
                      </a>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="has-text-secondary">Alumni</div>
            )}
          </div>
          <div className="column is-8">
            {!member.frontmatter.inactive && member?.html && (
              <div className="has-background-light mb-6 px-6 py-5">
                <HTMLContent
                  content={member?.html}
                  className={"markdown py-4"}
                ></HTMLContent>
              </div>
            )}
            <div className="has-text-weight-bold is-uppercase pb-5 has-text-secondary">
              Blog posts by {member.frontmatter.title}
            </div>
            <div className="blog mb-6">
              {posts &&
                posts.map((post: any, index: number) => (
                  <Post
                    hideAuthor={true}
                    key={`article-${index}`}
                    post={post}
                  />
                ))}
              {!(posts?.length > 0) && <div>No post.</div>}
            </div>
          </div>
        </div>
      </div>
      <DefaultBottom />
    </Layout>
  )
}

export default AuthorTemplate

// graphQL queries
export const pageQuery = graphql`
  query AuthorTemplate($id: String, $slug: String) {
    page: markdownRemark(id: { eq: $id }) {
      id
      frontmatter {
        title
        twitter
        job
        gravatar
        github
        country
        inactive
        location
      }
      fields {
        slug
      }
      html
    }
    posts: allMarkdownRemark(
      filter: {
        fields: { type: { eq: "blog" } }
        frontmatter: { author: { eq: $slug } }
      }
      sort: { fields: { order: DESC } }
      limit: 10
    ) {
      nodes {
        id
        fields {
          path
        }
        frontmatter {
          title
          publishedAt(formatString: "MMMM DD, YYYY")
          author
          category
          disqus
        }
        excerpt(pruneLength: 600, format: HTML)
      }
    }
  }
`
